import { useMemo } from 'react';

const HomeCopyright = () => {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return <span>© {currentYear} Kobai Inc.</span>;
};

export default HomeCopyright;
